const Bluex = {
  0: "#FCFDFF",
  50: "#F1F4FC",
  100: "#DAE2F6",
  200: "#B1C2ED",
  300: "#5378d7",
  400: "#1246C8",
  500: "#0E379E",
  600: "#0A266D",
  700: "#05153D"
};
const Tealx = {
  0: "#dcf8f1",
  100: "#b8f1e2",
  200: "#7ae4ca",
  300: "#3dd8b1",
  400: "#00bb8c",
  500: "#008a67",
  600: "#006a50",
  700: "#00392b"
};
const Pinkx = {
  0: "#ffecf2",
  100: "#fecfdd",
  200: "#fd9cb9",
  300: "#fc608e",
  400: "#d72f60",
  500: "#a3284c",
  600: "#6f1b34",
  700: "#3f0f1d"
};
const DeepBluex = {
  0: "#eaecf0",
  100: "#cbcfda",
  200: "#979fb5",
  300: "#626e90",
  400: "#2e3e6b",
  500: "#232f50",
  600: "#171f36",
  700: "#0c101b"
};
const Nudex = {
  0: "#fffefd",
  100: "#fefcfa",
  200: "#fdfaf6",
  300: "#fcf7f1",
  400: "#fcf5ed",
  500: "#eee7dd",
  600: "#bab4ac",
  700: "#85817b"
};
const Purplex = {
  0: "#f8f7fe",
  100: "#e1dff9",
  200: "#c2bff4",
  300: "#a49fee",
  400: "#867fe8",
  500: "#685fe3",
  600: "#5148cb",
  700: "#403aa2"
};
const Napolix = {
  0: "#f3fbff",
  100: "#d6f2ff",
  200: "#b5e7ff",
  300: "#83d8ff",
  400: "#5acaff",
  500: "#179fdf",
  600: "#1176a6",
  700: "#0b4d6c"
};
const Celestex = {
  0: "#e7fafd",
  100: "#aff0f8",
  200: "#4dddef",
  300: "#00c4db",
  400: "#00a9bd",
  500: "#008fa0",
  600: "#007684",
  700: "#005e69"
};
const Orangex = {
  0: "#fff4e6",
  100: "#ffe3bf",
  200: "#ffc680",
  300: "#ffaa40",
  400: "#ff8d00",
  500: "#bf6a00",
  600: "#804700",
  700: "#402300"
};
const Redx = {
  0: "#fbecec",
  100: "#f6d0d0",
  200: "#eca1a1",
  300: "#e37171",
  400: "#d94242",
  500: "#d01313",
  600: "#b60000",
  700: "#900000"
};
const Greenx = {
  0: "#ddf5eb",
  100: "#aee6d0",
  200: "#5acd9e",
  300: "#2bac78",
  400: "#22885f",
  500: "#1a6648",
  600: "#124631",
  700: "#0a291c"
};
const Greyx = {
  0: "#F9FAFA",
  100: "#F1F2F3",
  200: "#E3E5E8",
  300: "#D4D8DC",
  400: "#C6CBD1",
  500: "#B8BEC5",
  600: "#93989E",
  700: "#6E7276",
  800: "#4A4C4F",
  900: "#252627"
};
const AlphaDeepColor = "#171f36";
const AlphaDeep = {
  4: `${AlphaDeepColor}0a`,
  8: `${AlphaDeepColor}14`,
  10: `${AlphaDeepColor}1a`,
  12: `${AlphaDeepColor}1f`,
  16: `${AlphaDeepColor}29`,
  20: `${AlphaDeepColor}33`,
  24: `${AlphaDeepColor}3d`,
  30: `${AlphaDeepColor}4d`,
  38: `${AlphaDeepColor}61`,
  50: `${AlphaDeepColor}80`,
  56: `${AlphaDeepColor}8f`,
  60: `${AlphaDeepColor}99`,
  70: `${AlphaDeepColor}b3`
};
const GREY_BORDER_CARD = "rgba(23, 31, 54, 0.12)";
const GREY_BORDER_CARD_HOVERED = "rgba(23, 31, 54, 0.30)";
const WHITE_TRANSPARENT_LIGHT = "rgba(0, 0, 0, 0.08)";
export {
  AlphaDeep,
  Bluex,
  Celestex,
  DeepBluex,
  GREY_BORDER_CARD,
  GREY_BORDER_CARD_HOVERED,
  Greenx,
  Greyx,
  Napolix,
  Nudex,
  Orangex,
  Pinkx,
  Purplex,
  Redx,
  Tealx,
  WHITE_TRANSPARENT_LIGHT
};
//# sourceMappingURL=colors.es.js.map
